// Permisos de marcado de UNA línea, desde la tabla de líneas de la ficha del cliente.
//
// La pestaña Permisos configura al cliente entero (y pisa todas sus líneas). Esto es lo
// contrario: toca una sola línea y no mueve a las demás. Escribe todos los ANIs con los que
// esa línea puede salir, porque el AGI compara `ani_permissions.ani` contra el caller-ID.
import { useState, useEffect } from "react";
import { permFetch, safe, mono, Matriz } from "./permisosComunes";

export default function PermisosLineaModal({ linea, editable = true, onClose, onGuardado }) {
  const [data, setData] = useState(null);
  const [local, setLocal] = useState({});
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let vivo = true;
    (async () => {
      const r = await safe(() => permFetch(`/permissions/linea/${linea.id}`));
      if (!vivo) return;
      if (!r) { setErr("No se pudieron cargar los permisos de la línea"); return; }
      setData(r);
      setLocal(r.permisos);
    })();
    return () => { vivo = false; };
  }, [linea.id]);

  const guardar = async () => {
    setBusy(true); setErr(null);
    try {
      await permFetch(`/permissions/linea/${linea.id}/bulk`, "PUT", { permisos: local });
      onGuardado?.(linea);
      onClose();
    } catch (e) {
      setErr(e.message || "No se pudo guardar");
    } finally { setBusy(false); }
  };

  const cats = data?.categories || [];
  const difiere = (data?.difiere_de_general || []).length;

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", display:"flex",
      alignItems:"center", justifyContent:"center", zIndex:1100 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background:"var(--bg-surface)", borderRadius:"var(--r)",
        border:"1px solid var(--border)", padding:24, width:560, maxWidth:"92vw",
        maxHeight:"84vh", overflowY:"auto" }}>
        <div style={{ fontSize:15, fontWeight:700, color:"var(--text-primary)", marginBottom:4 }}>
          Permisos de marcado de la línea
        </div>
        <div style={{ fontSize:12, color:"var(--text-muted)", marginBottom:16 }}>
          Línea <code style={{ ...mono, color:"var(--brand)" }}>{linea.did_number}</code>
          {" — sólo esta línea. Para todas a la vez, la pestaña "}<strong>Permisos</strong>.
        </div>

        {!data && !err && (
          <div style={{ padding:"24px 0", textAlign:"center", color:"var(--text-secondary)", fontSize:12.5 }}>
            Cargando permisos…
          </div>
        )}

        {data && (
          <>
            <div style={{ fontSize:11, color:"var(--text-muted)", marginBottom:10 }}>
              {data.tiene_permisos_propios
                ? "Esta línea tiene permisos propios."
                : "Esta línea todavía marca con los valores por defecto de cada categoría."}
              {difiere > 0 && ` Difiere en ${difiere} categoría(s) de la general del cliente.`}
              {data.anis.length > 1 && (
                <> Se guardan para los {data.anis.length} números con los que puede salir:{" "}
                  <span style={mono}>{data.anis.join(", ")}</span>.</>
              )}
            </div>
            <Matriz cats={cats} valores={local} editable={editable && !busy}
              onChange={(k, v) => setLocal(p => ({ ...p, [k]: v }))}/>
          </>
        )}

        {err && <div style={{ marginTop:12, fontSize:12, color:"var(--danger)" }}>{err}</div>}

        <div style={{ display:"flex", gap:9, justifyContent:"flex-end", marginTop:16 }}>
          {data && editable && (
            <button className="nv-btn nv-btn-ghost" disabled={busy}
              onClick={() => setLocal({ ...data.general })}
              title="Copia acá los permisos generales del cliente (todavía hay que guardar)">
              ↺ Igualar a la general
            </button>
          )}
          <button className="nv-btn nv-btn-ghost" onClick={onClose}>Cerrar</button>
          {data && editable && (
            <button className="nv-btn nv-btn-primary" disabled={busy} onClick={guardar}>
              {busy ? "Guardando…" : "Guardar permisos de la línea"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
